<template>
  <LayoutContainer :id="data.cssId">
    <UtilityHeadline
      v-if="data.headlineH2"
      :class="`dbc-text-color-${data.headlineH2Color}`"
      :text="data.headlineH2"
      :level="2"
      :aos="{ fadeDirection: 'fade-right', delay: 350 }"
    />

    <Carousel
      :value="data.slides"
      :unstyled="false"
      circular
      :autoplayInterval="data.autoPlay ? data.speedInSeconds * 1000 : 0"
      data-aos="fade-up"
      data-aos-delay="350"
      :prev-button-props="{
        'aria-label': $t('dbc-aria-prev-button-label'),
      }"
      :next-button-props="{
        'aria-label': $t('dbc-aria-next-button-label'),
      }"
    >
      <template #item="slide">
        <div v-if="slide.data.video">
          <UtilityHeadline
            v-if="slide.data.headline_h3"
            :text="slide.data.headline_h3"
            :level="3"
          />

          <UtilityText v-if="slide.data.text" :text="slide.data.text" />

          <UtilityVideo
            :id="slide.data.video.id"
            :title="slide.data.video.title"
            :consentLayer="slide.data.video.consentLayer"
          />
        </div>

        <div
          v-else
          class="flex flex-nowrap items-center relative h-full max-tablet:flex-wrap max-tablet:flex-row"
          :class="`${
            slide.data.medium_position === 'right'
              ? 'flex-row-reverse'
              : 'flex-row'
          }`"
        >
          <div
            v-if="slide.data.image"
            class="flex grow-0 shrink max-tablet:basis-full"
            :class="`${
              slide.data.headline_h3 ||
              slide.data.text ||
              slide.data.button_text
                ? 'basis-[90%]'
                : 'basis-full'
            }`"
          >
            <NuxtLink
              v-if="slide.data.image_link"
              :to="slide.data.image_link"
              :target="resolveLinkTarget(slide.data.image_link)"
            >
              <UtilityImage
                :alt="slide.data.image_alt"
                :format="slide.data.image_format ?? 'f2-1'"
                :src="slide.data.image[0].url"
                loading="lazy"
                :copyright="slide.data.image_copyright"
              />
            </NuxtLink>
            <UtilityImage
              v-else
              :alt="slide.data.image_alt"
              :format="slide.data.image_format ?? 'f2-1'"
              :src="slide.data.image[0].url"
              loading="lazy"
              :copyright="slide.data.image_copyright"
            />
          </div>
          <div
            v-if="
              slide.data.headline_h3 ||
              slide.data.text ||
              slide.data.button_text
            "
            class="bg-white rounded-[14px] absolute max-w-[45%] w-auto px-s py-xs max-tablet:relative max-tablet:left-auto max-tablet:right-auto max-tablet:p-xs max-tablet:max-w-full max-tablet:w-auto"
            :class="`${
              slide.data.medium_position === 'left'
                ? 'right-0 mr-xs left-auto'
                : 'right-auto left-0 ml-xs'
            } ${
              slide.data.image_overlap || slide.data.image_overlap === null
                ? ''
                : 'relative'
            }`"
          >
            <UtilityHeadline
              v-if="slide.data.headline_h3"
              :text="slide.data.headline_h3"
              :level="3"
            />

            <UtilityText v-if="slide.data.text" :text="slide.data.text" />

            <div v-if="slide.data.button_text && slide.data.button_link">
              <UtilityButton
                :button="{
                  id: slide.data.id,
                  link: slide.data.button_link,
                  text: slide.data.button_text,
                  type: 'text',
                }"
              />
            </div>
          </div>
        </div>
      </template>
    </Carousel>
  </LayoutContainer>
</template>

<script setup lang="ts">
import Carousel from 'primevue/carousel'

const props = defineProps<{
  content: ImageSlider
}>()

const data = normalizeContentImageSlider(props.content)
</script>
